export const REPORT_COLUMNS_PREFRENCE = "REPORT_COLUMNS_PREFRENCE";
export const REPORT_COLUMNS_PREFRENCE_SUCCESS = "REPORT_COLUMNS_PREFRENCE_SUCCESS";
export const REPORT_COLUMNS_PREFRENCE_FAILED = "REPORT_COLUMNS_PREFRENCE_FAILED";
